import React from 'react'
import { View, TouchableOpacity, ColorPropType, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'
import color from 'color'

import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../VfText'

import styles from './Card.Styles'

function Card(props) {
  const {
    shadowLevel,
    children,
    onPress,
    withTitle,
    selected,
    title,
    accentColor,
    titleStyle,
    style,
    contentContainerStyle,
    isContentLoading,
    loadingBackgroundColor,
    loadingForegroundColor,
    ...rest
  } = props

  const theme = useTheme()

  return (
    <View style={style}>
      {withTitle && (
        <View style={[
          styles.title,
          {
            backgroundColor: accentColor
          }
        ]}>
          <VfText
            weight="bold"
            i18nKey={title}
            isLoading={isContentLoading}
            loadingBackgroundColor={loadingBackgroundColor}
            loadingForegroundColor={loadingForegroundColor}
            style={[
              {
                color: color(accentColor).isDark ? Colors.white : Colors.thinDark
              },
              titleStyle
            ]}
          />
        </View>
      )}
      <View
        {...rest}
        style={styles['elevation_' + shadowLevel]}
      >

        <TouchableOpacity
          disabled={!onPress}
          onPress={onPress}
          activeOpacity={0.7}
          style={StyleSheet.flatten([
            styles.cardRoot(theme),
            withTitle && styles.cardWithTitle,
            selected && {
              ...styles.selectedCard,
              borderColor: accentColor
            },
            contentContainerStyle
          ])}
        >
          {children}
        </TouchableOpacity>
      </View>
    </View>
  )

}

Card.propTypes = {
  children: PropTypes.node,
  shadowLevel: PropTypes.oneOf(['none', 'low', 'hight']),
  onPress: PropTypes.func,
  withTitle: PropTypes.bool,
  selected: PropTypes.bool,
  title: PropTypes.string,
  accentColor: PropTypes.string,
  titleStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  contentContainerStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  isContentLoading: PropTypes.bool,
  loadingBackgroundColor: ColorPropType,
  loadingForegroundColor: ColorPropType
}

Card.defaultProps = {
  shadowLevel: 'low',
  withTitle: false,
  title: '',
  titleStyle: {},
  accentColor: Colors.ocean
}

export default Card
